import { LOGO_URL } from "@/data/siteContent";

export function resolveImageUrl(image) {
  if (!image) return "";
  if (image.file_id) return `${process.env.REACT_APP_BACKEND_URL}/api/files/${image.file_id}`;
  return image.url || "";
}

export function resolveLogoUrl(settings, language) {
  const languageLogo = language === "es" ? settings?.logo_url_es : settings?.logo_url_en;
  return languageLogo || settings?.logo_url || LOGO_URL;
}
